var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.128,
    height: 30.714,
    viewBox: "0 0 25.128 30.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58430",
    "data-name": "Group 58430",
    transform: "translate(-13208.718 16599.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M460.567,7.234c.267-.027.534-.049.8-.092a4.866,4.866,0,0,0,2.024-.879,7.308,7.308,0,0,0,1.784-1.846,7.155,7.155,0,0,0,1.154-2.771,7.384,7.384,0,0,0,.1-1.58.773.773,0,0,0-.035-.167,2.445,2.445,0,0,0-.356.027,9.781,9.781,0,0,0-1.636.5,6.3,6.3,0,0,0-2.687,2.159A7.571,7.571,0,0,0,460.357,6.9c0,.1,0,.194,0,.313A1.145,1.145,0,0,0,460.567,7.234Z",
    transform: "translate(12760.77 -16598.955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M.184,270.362c.046.283.086.566.135.849.059.342.1.69.186,1.027.119.477.264.946.4,1.418a17.62,17.62,0,0,0,1.105,2.79,20.936,20.936,0,0,0,2.332,3.8,7.988,7.988,0,0,0,1.774,1.714,3.851,3.851,0,0,0,1.682.666,3.527,3.527,0,0,0,1.782-.3c.588-.237,1.162-.517,1.749-.752a2.937,2.937,0,0,1,.825-.216,16.115,16.115,0,0,1,1.615-.054,2.946,2.946,0,0,1,1.162.175c.45.2.9.4,1.348.6a7.4,7.4,0,0,0,1.41.493A3.082,3.082,0,0,0,19.2,282.5a4.858,4.858,0,0,0,2.127-1.361,12.676,12.676,0,0,0,1.946-2.663,32.707,32.707,0,0,0,1.906-4.057.41.41,0,0,0,.016-.129c-.4-.229-.787-.434-1.156-.671a5.932,5.932,0,0,1-2.358-2.79,7.235,7.235,0,0,1-.512-2.431,6.66,6.66,0,0,1,.5-3.019,7.833,7.833,0,0,1,1.58-2.353c.367-.38.76-.736,1.17-1.132a7.345,7.345,0,0,0-1.73-1.747,6.61,6.61,0,0,0-3.585-1.218,6.8,6.8,0,0,0-2.264.207c-.736.218-1.456.488-2.186.725a8.419,8.419,0,0,1-1.256.364,3.4,3.4,0,0,1-1.69-.2c-.636-.235-1.27-.477-1.914-.685a7.16,7.16,0,0,0-1.224-.291A9,9,0,0,0,7.335,259a6.332,6.332,0,0,0-2.121.407,7.136,7.136,0,0,0-3.361,2.668,9.331,9.331,0,0,0-1.515,3.547,14.314,14.314,0,0,0-.243,1.889,18.3,18.3,0,0,0,.07,2.744A.718.718,0,0,0,.184,270.362Z",
    transform: "translate(13208.651 -16850.986)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.7d6f159dcdfa2fa1a0ed1b476d8c0e69.svg";
export { ForwardRef as ReactComponent };